import { render } from "./ProgressBarComponent.vue?vue&type=template&id=1ab3a12b&ts=true"
import script from "./ProgressBarComponent.vue?vue&type=script&lang=ts"
export * from "./ProgressBarComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__